import React, { useEffect, useState } from 'react';

/**
 * 되돌릴 수 없는 동작 — 첫 번째 누름은 무엇이 일어나는지 보이고, 4초 안에 한 번 더 누르면 한다(2026-10-08, #108).
 * 브라우저 확인창(confirm)은 쓰지 않는다. 재무계획 확정 · 수주/실주 · 참여 안 함이 쓰던 두 번 누르기를 한 부품으로
 */
export const ConfirmButton: React.FC<{
  onConfirm: () => void | Promise<unknown>;
  /** 평소 모양 — 아이콘이나 글자 */
  children: React.ReactNode;
  /** 첫 번째 누른 뒤 보일 말 — 「한 번 더 누르면 지웁니다」 */
  ask: string;
  className?: string;
  /** 첫 번째 누른 뒤 모양 */
  armedClassName?: string;
  title?: string;
  disabled?: boolean;
}> = ({ onConfirm, children, ask, className = '', armedClassName, title, disabled }) => {
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (!armed) return;
    const t = setTimeout(() => setArmed(false), 4000);
    return () => clearTimeout(t);
  }, [armed]);
  return (
    <button
      type="button"
      title={armed ? undefined : title}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (!armed) { setArmed(true); return; }
        setArmed(false);
        onConfirm();
      }}
      className={armed ? armedClassName ?? 'rounded-lg px-2.5 py-1 text-xs font-medium bg-red-600 text-white hover:bg-red-700 whitespace-nowrap' : className}
    >
      {armed ? ask : children}
    </button>
  );
};
